export default "__VITE_ASSET__a6dae4c1__"